const IconUp = () => {
  window.addEventListener('scroll', function () {
    const iconWrapper = document.querySelector('.icon-up__icon');
    if (iconWrapper) {
      const scrollPosition = window.scrollY;

      // Add 'show' class only after passing one viewport height
      if (scrollPosition > window.innerHeight) {
        iconWrapper.classList.add('show');
      } else {
        iconWrapper.classList.remove('show');
      }
    }
  });
};

const icon = document.querySelector('.icon-up');
if (icon) {
  icon.addEventListener('click', function () {
    const scrollPosition = window.scrollY;

    if (scrollPosition <= 0) {
      // At top → scroll down one viewport
      window.scrollTo({
        top: window.innerHeight,
        behavior: 'smooth',
      });
    } else {
      // Otherwise → scroll back to top
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  });
}

export default IconUp;